import * as Sentry from '@sentry/react';
import { ResponseBody } from '~/core/api/ResponseTypes';
import SRError, { isSRError } from '~/utils/errors/srError';

interface ICaptureFetchErrorToSentry {
    url: string;
    error: Error | SRError;
    response?: Response;
    responseBody?: ResponseBody;
    request?: RequestInit;
    extra?: any;
}

export const captureFetchErrorToSentry = async ({
    url,
    error,
    response,
    responseBody,
    request,
    extra,
}: ICaptureFetchErrorToSentry) => {
    const pureError = isSRError(error) ? error.originalError : error;
    const srError = isSRError(error) ? error : null;

    const simplifiedData = {
        resultsSize: responseBody?.data.results.length,
        results: responseBody?.data.results.map((result) => ({
            hits: result.hits.length,
            aggrs: result.aggregations.length,
            qsId: result.querySetIdentifier,
            totalRecords: result.totalRecords,
        })),
    };

    const contexts = {
        request: {
            url: url,
            options: request,
        },
        response: {
            status: response?.status,
            body: { data: simplifiedData, error: responseBody?.errors },
        },
    };

    const extras = {
        ...extra,
        body: JSON.stringify({
            status: response?.status,
            data: simplifiedData,
            errors: responseBody?.errors,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            error: responseBody?.error,
        }),
    };

    if (pureError) {
        Sentry.captureException(pureError, {
            contexts,
            level: 'error',
            tags: { 'api.url': url },
            extra: extras,
        });
    } else {
        console.log({ name: error.name });
        Sentry.captureMessage(error.name, {
            contexts,
            level: 'error',
            tags: { 'api.url': url },
            extra: extras,
        });
    }
};
